import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const CompanionSidebar = (props) => {
    const dispatch = useDispatch();
    const companionInfo = useSelector(state => state.companionInfo.value);
    const [showNewComp, setShowNewComp] = useState(false);
    const loginInfo = useSelector(state => state.loginInfo.value);

    useEffect(() => {
        console.log(companionInfo);
    }, [companionInfo])
    return (
        <div
            className='d-flex flex-column p-3 text-white bg-dark'
            style={{ height: '100%', width: '245px' }}
        >
            <Link
                to='/Admin/Companion2'
                className='d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none'
            >
            <span className='fs-5'>
            <i style={{color: '#D6B8F5' }} className='fa-solid fa-table' />
            {'   '}
            Companion Tables
            </span>
            </Link>
            <hr />
             {/*
                <span style={{cursor: 'pointer'}} ><i style={{color: '#B8DAF5'}} className='fa-regular fa-table' /> Batchs </span>
                <span style={{cursor: 'pointer'}} ><i style={{color: '#B8DAF5'}} className='fa-regular fa-table' /> Vendor List </span>
            */}
            {companionInfo.loaded === true && companionInfo.companions.length > 0 &&
                companionInfo.companions.map((comp) => (
                    <span key={comp.id} style={{cursor: 'pointer'}} >
                        <Link to={'/Admin/Companion2/' + comp.id} style={{textDecoration: 'none', color: '#FFF'}}><i style={{color: '#B8DAF5'}} className='fa-regular fa-table' /> {comp.companionName}</Link>
                     {loginInfo !== undefined && loginInfo.trinDocsLicenseLevel === 5 &&
                        <span className='ms-2' onClick={() => props.UpdateSchema(comp.id)} style={{cursor: 'pointer'}} ><i style={{color: '#87FF85'}} className='fa-regular fa-pencil' />  </span>
                    }</span>
                ))
            }
            {companionInfo.loaded === true && companionInfo.companions.length === 0 &&
                <div className='mt-3 mb-3 row justify-content-md-center text-center'>
                    <div className='col-10'>No Companions Configrued </div>
                </div>
            }
            <hr />
            {loginInfo !== undefined && loginInfo.trinDocsLicenseLevel === 5 &&
                <span onClick={props.showNew} style={{cursor: 'pointer'}} ><i style={{color: '#87FF85'}} className='fa-regular fa-table-layout' /> New Companion Table </span>
            }
        </div>
    );
}

export default CompanionSidebar;